if (!customElements.get('variant-selects')) {

  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.productWrapper = this.closest('.thb-product-detail');
      this.other = Array.from(this.productWrapper?.querySelectorAll('variant-selects') || []).filter((selector) => {
        return selector !== this && selector.dataset.section === this.dataset.section;
      });
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.renderController = null;
      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-variant-retry]') || !this.currentVariant) return;
        event.preventDefault();
        this.retryRequested = true;
        this.renderProductInfo();
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    disconnectedCallback() {
      this.renderController?.abort();
      this.purchaseNodes = null;
    }

    setPurchaseState(state) {
      const purchase = this.productWrapper?.querySelector('[data-product-purchase]');
      if (!purchase) return;
      const canBuy = state === 'ready' && this.currentVariant?.available && Number(this.currentVariant.price) > 0;
      purchase.dataset.variantState = state;
      purchase.setAttribute('aria-busy', String(state === 'loading'));
      const input = purchase.querySelector('input[name="id"]');
      if (input) input.disabled = !canBuy;
      purchase.querySelectorAll('[data-dynamic-checkout]').forEach((checkout) => {
        checkout.hidden = !canBuy;
        checkout.toggleAttribute('inert', !canBuy);
      });
      if (state !== 'ready') this.toggleAddButton(true, '', false);
      this.productWrapper.querySelector('[data-pdp-price]')?.classList.toggle('visibility-hidden', state !== 'ready');
      this.getSectionsToRender().filter((id) => id.startsWith('price-')).forEach((id) => {
        document.getElementById(id)?.classList.toggle('visibility-hidden', state !== 'ready');
      });
    }

    showVariantError(show) {
      const error = this.querySelector('[data-variant-error]');
      if (error) error.hidden = !show;
    }

    updatePurchaseContent(html) {
      const target = this.productWrapper?.querySelector('[data-product-purchase-content]');
      const source = html.querySelector('[data-product-purchase-content]');
      if (!target || !source) return;
      const wasConsult = !!target.querySelector('[data-product-consult]');
      const isConsult = !!source.querySelector('[data-product-consult]');
      // Preserve the existing native form and app/gift-card fields for paid-to-paid changes.
      if (wasConsult === isConsult) return;
      if (!wasConsult) {
        // Retain native nodes, including app state, gift fields and file selections.
        this.purchaseNodes = Array.from(target.childNodes);
        target.innerHTML = source.innerHTML;
      } else if (this.purchaseNodes) {
        target.replaceChildren(...this.purchaseNodes);
        this.purchaseNodes = null;
      } else {
        target.innerHTML = source.innerHTML;
      }
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.renderController?.abort();
      this.setPurchaseState('loading');
      this.showVariantError(false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        this.setPurchaseState('unavailable');
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.textContent = this.options[i];
        }
      });
    }
    updateMasterId() {
      if (!this.getVariantData()) {
        return;
      }
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }


updateMedia() {
  if (!this.currentVariant) return;
  if (!this.currentVariant.featured_media) return;

  let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

  this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                      `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                      this.productSlider,
                      thumbnails);
}

setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
  if (!productSlider) return;
  let activeMedia = productSlider.querySelector(mediaId);

  if (productSlider.flkty && this.hideVariants) {

    let previousActiveSlide = productSlider.querySelector('.product-images__slide.is-initial-selected');
    if (previousActiveSlide) {
      previousActiveSlide.classList.remove('is-initial-selected');
    }

    let previousActiveThumb = thumbnails?.querySelector('.product-thumbnail.is-initial-selected');
    if (previousActiveThumb) {
      previousActiveThumb.classList.remove('is-initial-selected');
    }

    [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
      el.classList.remove('is-active');
    });

    // General images, videos and 3D models remain available, as in the Liquid render.
    [].forEach.call(thumbnails?.querySelectorAll('.product-thumbnail.product-images__slide-item--variant') || [], function (el) {
      el.classList.remove('is-active');
    });

    if (activeMedia) {
      activeMedia.classList.add('is-active');
      activeMedia.classList.add('is-initial-selected');
    }

    let activeThumb = thumbnails?.querySelector(thumbId);
    if (activeThumb) {
      activeThumb.classList.add('is-active');
      activeThumb.classList.add('is-initial-selected');
    }

    if (productSlider.reInit) {
      productSlider.reInit(this.imageSetIndex);
    }

    if (productSlider.flkty) {
      productSlider.flkty.selectCell(mediaId);
    }

  } else if (productSlider.flkty) {
    productSlider.flkty.selectCell(mediaId);
  }
  productSlider.syncThumbnailState?.();
}






    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.currentVariant.id);
      window.history.replaceState({}, '', url.href);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = [
        document.getElementById(`product-form-${this.dataset.section}`),
        ...Array.from(this.productWrapper?.querySelectorAll('form.installment, form[id^="product-form-installment-"]') || [])
      ].filter(Boolean);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.productWrapper?.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.clearAvailability();
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--mobile`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      if (!this.currentVariant) return Promise.resolve();
      this.setPurchaseState('loading');
      this.showVariantError(false);
      const sections = this.getSectionsToRender();
      const requestedVariantId = this.currentVariant.id;

      if (this.renderController) this.renderController.abort();
      this.renderController = new AbortController();
      const controller = this.renderController;

      return fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.section}`, {
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Variant request failed: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          if (controller.signal.aborted || !this.isConnected || this.currentVariant?.id !== requestedVariantId) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const purchase = this.productWrapper?.querySelector('[data-product-purchase-content]');
          if (purchase && !html.querySelector('[data-product-purchase-content]')) throw new Error('Missing purchase content');
          const price = this.productWrapper?.querySelector('[data-pdp-price]');
          const nextPrice = html.querySelector('[data-pdp-price]');
          if (price && !nextPrice) throw new Error('Missing price content');
          this.updatePurchaseContent(html);
          if (price && nextPrice) {
            price.innerHTML = nextPrice.innerHTML;
            price.dataset.sinPrecio = nextPrice.dataset.sinPrecio;
          }

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }

          });
          this.setPurchaseState('ready');
          this.updateVariantInput();
          if (this.retryRequested) {
            this.querySelector('select, input:checked')?.focus();
            this.retryRequested = false;
          }
          if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
          const isConsultVariant = Number(this.currentVariant.price) <= 0;
          this.toggleAddButton(
            !this.currentVariant.available || isConsultVariant,
            isConsultVariant ? 'Price on request' : window.theme.variantStrings.soldOut
          );

        })
        .catch((error) => {
          if (error.name === 'AbortError' || this.currentVariant?.id !== requestedVariantId) return;
          this.setPurchaseState('error');
          this.showVariantError(true);
        })
        .finally(() => {
          if (this.renderController === controller) this.renderController = null;
        });
    }

    getSubmitButtons() {
      const sectionId = this.dataset.section;
      return document.querySelectorAll(
        `product-form[data-section="${sectionId}"] .single-add-to-cart-button, ` +
        `product-add-to-cart-sticky[data-section="${sectionId}"] .single-add-to-cart-button`
      );
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = this.getSubmitButtons();

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
          // Only whoever asks for modifyClass adds/removes the class.
          // onVariantChange() passes false while it resolves the variant: that
          // is a pass-through state and we do not want the button to flash grey.
          if (modifyClass) submitButton.classList.add('sold-out');
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          // This was missing and it is the bug: after picking a variant with no
          // stock the button kept .sold-out, which in product-add-to-cart.liquid
          // is opacity:0.5 + cursor:not-allowed. Coming back to a variant WITH
          // stock removed the disabled attribute but not the class, so the
          // button was clickable yet painted grey with a blocked cursor: it
          // looked dead and nobody touched it.
          if (modifyClass) submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });
    }

    setUnavailable() {
      const submitButtons = this.getSubmitButtons();
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_mobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        // It checked submitButton, which cannot be null here (it comes from the
        // forEach). The one that can be missing is the text span, and if it was
        // the line below threw a TypeError and cut the rest of the method short.
        if (!submitButtonText) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
      if (price_mobile) price_mobile.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          // With no valid variant we must use what the visitor actually PICKED,
          // which is exactly what updateOptions() left in this.options.
          //
          // It used to look up the first variant matching option1 and take ITS
          // option2 as if that were the selection: when the combination did not
          // exist, it invented a value. Measured on AR's volante-spider-m6-330,
          // which has ACERO in all 3 colours but ALUMINIO only in DARK: picking
          // ALUMINIO + ROJO FLUOR built [ALUMINIO, DARK], and further down the
          // rule that marks the selection as unavailable ended up disabling
          // DARK — the only combination that DOES exist. The visitor saw the
          // good option greyed out and the broken one enabled.
          //
          // Also: that block assumed exactly two options. A product with three
          // (size/colour/material) was built wrong.
          selected_options = this.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {

        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Resolve each option against its preceding selections only. Requiring
          // later values to match makes sparse three-option products impossible
          // to reach through dropdowns (both later controls become disabled).
          const position = Number(index.replace('option', ''));
          const matchesPreviousOptions = selected_options
            .filter((option) => Number(option.index.replace('option', '')) < position)
            .every((option) => variant[option.index] === option.value);

          if (variant.available && matchesPreviousOptions) {
            entry.isUnavailable = false;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail') || [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        dragThreshold: 10
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      this.setupEvents();

      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      this.eventsController?.abort();
      this.eventsController = new AbortController();
      const signal = this.eventsController.signal;
      this.prev_button?.addEventListener('click', () => this.flkty.previous(), { signal });
      this.next_button?.addEventListener('click', () => this.flkty.next(), { signal });
      this.thumbnail_container?.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-product-thumbnail]');
        if (!thumbnail || !this.thumbnail_container.contains(thumbnail) || !thumbnail.classList.contains('is-active')) return;
        this.flkty.selectCell('#' + thumbnail.dataset.mediaTarget);
        this.syncThumbnailState();
      }, { signal });
      this.syncThumbnailState();
      this.video_containers.forEach((container) => {
        container.querySelector('button')?.addEventListener('click', function () {
          container.setAttribute('hidden', '');
        }, { signal });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        const previous_slide = this.flkty.cells[_this.selectedIndex]?.element;
        const previous_media = previous_slide?.querySelector('.product-single__media');
        this.syncThumbnailState(true);
        if (!previous_media) return;

        if (previous_media.classList.contains('product-single__media-external-video')) {
          // Origen exacto del iframe para postMessage (nunca '*').
          const video_iframe = previous_media.querySelector('iframe');
          const video_origin = (fallback) => {
            if (!video_iframe || !video_iframe.src) return fallback;
            try {
              return new URL(video_iframe.src, window.location.href).origin;
            } catch (e) {
              return fallback;
            }
          };
          if (video_iframe && previous_media.dataset.provider === 'youtube') {
            video_iframe.contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), video_origin('https://www.youtube.com'));
          } else if (video_iframe && previous_media.dataset.provider === 'vimeo') {
            video_iframe.contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), video_origin('https://player.vimeo.com'));
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


    }
    syncThumbnailState(scroll = false) {
      const selectedId = this.flkty?.selectedElement?.id;
      let active;
      this.thumbnails?.forEach((thumbnail) => {
        const selected = thumbnail.dataset.mediaTarget === selectedId;
        thumbnail.classList.toggle('is-initial-selected', selected);
        thumbnail.setAttribute('aria-pressed', String(selected));
        if (selected) active = thumbnail;
      });
      if (!scroll || !active) return;
      requestAnimationFrame(() => {
        if (!active.isConnected || !active.offsetParent) return;
        const parent = active.parentElement;
        parent.scrollTo({
          left: active.offsetLeft - parent.clientWidth / 2 + active.clientWidth / 2,
          top: active.offsetTop - parent.clientHeight / 2 + active.clientHeight / 2,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }
    disconnectedCallback() {
      this.eventsController?.abort();
      this.zoomController?.abort();
      this.cancelPendingZoom?.();
      this.flkty?.destroy();
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item, index) => {
        // PhotoSwipe contains images only; video/model cells are not indexes in this list.

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.zoomController?.abort();
      this.zoomController = new AbortController();
      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link), { signal: this.zoomController.signal });
        ['pointerenter', 'focus'].forEach((eventName) => {
          link.addEventListener(eventName, () => this.loadZoomAssets().catch(() => {}), {
            signal: this.zoomController.signal, passive: true
          });
        });
      }));
    }
    loadZoomAssets() {
      if (typeof PhotoSwipe !== 'undefined' && typeof PhotoSwipeUI_Default !== 'undefined') {
        return Promise.resolve();
      }
      if (ProductSlider.zoomAssetsPromise) return ProductSlider.zoomAssetsPromise;
      const sources = [
        [this.pswpElement?.dataset.photoswipeSrc, 'PhotoSwipe'],
        [this.pswpElement?.dataset.photoswipeUiSrc, 'PhotoSwipeUI_Default']
      ];
      if (sources.some(([src]) => !src)) return Promise.reject(new Error('Missing zoom assets'));
      // Both files download together; async=false preserves core -> UI execution.
      ProductSlider.zoomAssetsPromise = Promise.all(sources.map(([src, globalName]) => {
        if (window[globalName]) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const absoluteSrc = new URL(src, document.baseURI).href;
          const existing = Array.from(document.scripts).find((script) => script.src === absoluteSrc);
          const script = existing || document.createElement('script');
          const finish = (error) => {
            clearTimeout(timeout);
            script.removeEventListener('load', onLoad);
            script.removeEventListener('error', onError);
            if (error) {
              if (!existing) script.remove();
              reject(error);
            } else resolve();
          };
          const onLoad = () => finish(window[globalName] ? null : new Error('Invalid zoom asset'));
          const onError = () => finish(new Error('Zoom asset unavailable'));
          const timeout = setTimeout(onError, 20000);
          script.addEventListener('load', onLoad, { once: true });
          script.addEventListener('error', onError, { once: true });
          if (!existing) {
            script.async = false;
            script.src = src;
            document.head.appendChild(script);
          }
        });
      })).catch((error) => {
        ProductSlider.zoomAssetsPromise = null;
        throw error;
      });
      return ProductSlider.zoomAssetsPromise;
    }
    cancelPendingZoom() {
      if (!this.pendingZoom) return;
      this.pendingZoom.link.removeAttribute('aria-busy');
      this.pendingZoom.controller.abort();
      this.pendingZoom = null;
    }
    zoomClick(e, link) {
      e.preventDefault();
      if (typeof PhotoSwipe !== 'undefined' && typeof PhotoSwipeUI_Default !== 'undefined') {
        this.openZoom(link);
        return;
      }
      if (this.pendingZoom?.link === link) return;
      this.cancelPendingZoom();
      const pending = { link, controller: new AbortController() };
      this.pendingZoom = pending;
      link.setAttribute('aria-busy', 'true');
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.cancelPendingZoom();
      }, { signal: pending.controller.signal });
      const stillRelevant = () => this.pendingZoom === pending && this.isConnected && link.isConnected &&
        link.closest('.product-images__slide')?.classList.contains('is-active');
      this.loadZoomAssets().then(() => {
        if (stillRelevant()) this.openZoom(link);
      }).catch(() => {
        // The original image remains a usable fallback if its current view is still active.
        if (stillRelevant()) window.location.assign(link.href);
      }).finally(() => {
        if (this.pendingZoom === pending) this.cancelPendingZoom();
      });
    }
    openZoom(link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        // Wait for PhotoSwipe to hide the dialog and remove its focus trap.
        pswp.listen('destroy', () => requestAnimationFrame(() => {
          if (!this.isConnected || this.pswpElement.getAttribute('aria-hidden') !== 'true') return;
          const targets = [link, this.querySelector('.product-images__slide.is-selected .product-single__media-zoom')];
          const target = targets.find((element) => element?.isConnected &&
            !element.closest('[inert], [aria-hidden="true"]') &&
            element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
          target?.focus({ preventScroll: true });
        }));
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;
      this.dataset.initialized = 'true';
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) variantInput.disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      const purchase = this.closest('[data-product-purchase]');
      if (purchase && purchase.dataset.variantState !== 'ready') return;
      if (this.form.querySelector('input[name="id"]')?.disabled) return;

      if (!this.validateQuantityInput()) {
        return;
      }

      if (!this.form.reportValidity()) {
        return;
      }

      // Candado contra el doble submit. Ya habia un guard con la misma intencion
      // (el `if (...contains('loading')) return` de abajo) pero estaba adentro del
      // forEach: su return sale del callback, no del handler, asi que el segundo
      // toque se salteaba la decoracion del boton y seguia derecho al fetch.
      // Reproducido: dos toques a 70ms -> item_count 2. aria-disabled tampoco lo
      // frena: solo se lo cuenta a los lectores de pantalla, el boton sigue
      // clickeable. En un producto de $7M, un dedo rapido compraba dos.
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const enqueue = window.CollinoCart?.enqueue || ((operation) => operation());
      return enqueue(() => fetch(`${theme.routes.cart_add_url}`, config)
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok && !data.status) throw new Error('Cart request failed: ' + response.status);
          return data;
        })
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
          // Sin esto el fallo era MUDO: si el POST no llegaba o la respuesta no era
          // JSON (red caida, 429, error del servidor), el usuario tocaba "Agregar al
          // carrito", el spinner iba y volvia, y no pasaba nada. Ni mensaje ni pista:
          // solo un console.error que nadie ve. Contradecia la regla de CLAUDE.md
          // ("Mostra errores claros"). El wrapper de error ya existia y quedaba
          // vacio; solo faltaba llenarlo en esta rama.
          this.handleErrorMessage(
            (window.theme && window.theme.strings && window.theme.strings.cartError) ||
            'We could not add the product. Please try again.'
          );
        })
        .finally(() => {
          // Se libera SIEMPRE (tambien si el POST fallo o el JSON vino roto):
          // si no, un error dejaria el boton trabado y el producto no se podria
          // agregar nunca mas sin recargar.
          this.isSubmitting = false;
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        }));
    }

    validateQuantityInput() {
      const quantityInput = this.form?.querySelector('input[name="quantity"]');
      if (!quantityInput) return true;

      const min = parseInt(quantityInput.getAttribute('min'), 10) || 1;
      const maxAttr = quantityInput.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      const step = parseInt(quantityInput.getAttribute('step'), 10) || 1;
      const value = Number(quantityInput.value);
      const roundedValue = Math.round(value);
      let message = '';

      if (!Number.isFinite(value)) {
        message = 'Please enter a valid quantity.';
        quantityInput.value = min;
      } else if (roundedValue < min) {
        message = `The minimum quantity is ${min}.`;
        quantityInput.value = min;
      } else if (roundedValue > max) {
        message = `Only ${max} available.`;
        quantityInput.value = max;
      } else if ((roundedValue - min) % step !== 0) {
        message = `Quantity must go up in steps of ${step}.`;
        quantityInput.value = min;
      } else if (String(roundedValue) !== quantityInput.value) {
        quantityInput.value = roundedValue;
      }

      if (!message) {
        quantityInput.setCustomValidity('');
        return true;
      }

      quantityInput.setCustomValidity(message);
      quantityInput.reportValidity();
      this.handleErrorMessage(message);
      quantityInput.focus();
      quantityInput.setCustomValidity('');
      return false;
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const sourceHtml = parsedState.sections?.[section.section];
        if (!sourceHtml) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const sourceInnerHTML = this.getSectionInnerHTML(sourceHtml, section.selector);
        if (sourceInnerHTML == null) {
          return;
        }
        elementToReplace.innerHTML = sourceInnerHTML;

      }));


      let product_drawer = document.getElementById('Product-Modal');

      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.hide();
      }
      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
        document.getElementById('Cart-Drawer').removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      const _this = this;
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById('footer');
      if (!form || !footer) return;
      _this.formPassed = false;

      // Se calcula por geometria en vez de depender de que el IntersectionObserver
      // dispare. El observer solo corre al CRUZAR un threshold, y con [0, 1] hay un
      // caso que nunca cruza: si el form arranca DEBAJO del viewport (ratio 0) y el
      // usuario salta el scroll de una -restauracion al volver atras, link con
      // ancla-, termina ARRIBA del viewport (ratio 0 otra vez). Ningun cruce, ningun
      // callback, y la barra no aparecia nunca. Verificado: scrollTo(0, 1600) desde
      // 0 -> no aparece; bajando por pasos -> aparece.
      //
      // La condicion es la misma de antes, escrita directo: la barra se ve si el
      // form ya quedo arriba y el footer todavia no entro.
      const evaluate = () => {
        const formRect = form.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        _this.formPassed = formRect.bottom <= 0;
        const show = _this.formPassed && footerRect.top >= vh;
        _this.classList.toggle('sticky--visible', show);
        // Espejo en <body> para poder ocultar la pestana de WhatsApp y el banner de
        // sugerencia de tienda cuando la barra esta visible, sin depender de :has().
        document.body.classList.toggle('atc-sticky-visible', show);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          evaluate();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      // Estado inicial: cubre la carga con scroll ya restaurado, que es justo el
      // caso que el observer se perdia.
      evaluate();
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
